import { Tokens } from '@/assets/tokens'
import { formatNumber } from '@/utils/numbers'
import { Comments, DataAll, Eyes, GrinningFaceWithSquintingEyes, Share, ThumbsUp } from '@icon-park/react'
import { EngagementContainer, EngagementItem, EngagementMetrics } from './Engagement.styles'

interface EngagementData {
  likes?: number
  comments?: number
  views?: number
  reactions?: number
  shares?: number
  totalInteractions?: number
}

interface EngagementRowProps {
  engagement: EngagementData
}

export function EngagementRow({ engagement }: EngagementRowProps) {
  const formatEngagementNumber = (value?: number) => {
    if (!value || value === 0) return '0'
    return formatNumber(value)
  }

  const engagementItems = [
    {
      icon: <ThumbsUp size={16} color={Tokens.ColorUIPrimary} />,
      value: engagement.likes,
      label: 'Curtidas',
    },
    {
      icon: <Comments size={16} color={Tokens.ColorUIPrimary} />,
      value: engagement.comments,
      label: 'Comentários',
    },
    {
      icon: <Eyes size={16} color={Tokens.ColorUIPrimary} />,
      value: engagement.views,
      label: 'Visualizações',
    },
    {
      icon: <GrinningFaceWithSquintingEyes size={16} color={Tokens.ColorUIWarn} />,
      value: engagement.reactions,
      label: 'Reações',
    },
    {
      icon: <Share size={16} color={Tokens.ColorUIDanger} />,
      value: engagement.shares,
      label: 'Compartilhamentos',
    },
    {
      icon: <DataAll size={16} color={Tokens.ColorTextPrimary} />,
      value: engagement.totalInteractions,
      label: 'Total',
    },
  ]

  return (
    <EngagementContainer>
      <EngagementMetrics>
        {engagementItems.map(
          (item, index) =>
            item.value !== undefined && (
              <EngagementItem key={index} title={item.label}>
                {item.icon}
                <span>{formatEngagementNumber(item.value)}</span>
              </EngagementItem>
            ),
        )}
      </EngagementMetrics>
    </EngagementContainer>
  )
}
